import { createContext, useContext, useState, useEffect } from 'react';

// Tüm diller için çeviri verileri
const translations = {
  en: {
    search_placeholder: "Search products...",
    all_products: "All Products",
    category_products: "Category Products",
    go_to_store: "Go to Store",
    admin: "Admin",
    categories: "Categories",
    hero_title: "Compare Prices.",
    hero_subtitle: "Shop Smarter!",
    hero_description: "Compare prices from AliExpress, Temu, and Shein instantly. Smart shopping, smart savings!",
    hero_cta: "Start Comparing",
    best_prices: "Best Prices",
    compare_platforms: "Compare 3 platforms",
    auto_updates: "Auto Updates",
    realtime_sync: "Real-time sync",
    safe_shopping: "Safe Shopping",
    direct_stores: "Direct to stores",
    products: "products",
    view_all: "View All",
    popular_products: "Popular Products",
    most_compared: "Most compared products",
    compare_prices: "Compare Prices",
    similar_products: "Similar Products",
    product_details: "Product Details",
    product_description: "Product Description",
    price_comparison: "Price Comparison",
    best_price: "Best Price",
    from: "from",
    buy_now: "Buy Now",
    out_of_stock: "Out of Stock",
    savings: "Save",
    in_stock: "In Stock",
    price_range: "Price Range",
    platforms: "Platforms",
    filters: "Filters",
    clear_filters: "Clear Filters",
    sort_by: "Sort by",
    popular: "Popular",
    price_low_high: "Price: Low to High",
    price_high_low: "Price: High to Low",
    newest: "Newest",
    biggest_discount: "Biggest Discount",
    footer_description: "Compare prices across AliExpress, Temu, and Shein. Find the best deals instantly.",
    quick_links: "Quick Links",
    home: "Home",
    contact: "Contact",
    privacy_policy: "Privacy Policy",
    terms_of_service: "Terms of Service",
    all_rights_reserved: "All rights reserved.",
    no_products_found: "No products found",
    try_adjusting_filters: "Try adjusting your filters",
    product_not_found: "Product not found",
    link_copied: "Link copied!",
    share: "Share",
    everything_here: "Everything you need is here",
    dont_miss: "Don't Miss Better Prices!",
    compare_thousands: "Compare thousands of products with GLOBAL and find the best deals!",
  },
  tr: {
    search_placeholder: "Ürün ara...",
    all_products: "Tüm Ürünler",
    category_products: "Kategori Ürünleri",
    go_to_store: "Mağazaya Git",
    admin: "Yönetici",
    categories: "Kategoriler",
    hero_title: "Fiyatları",
    hero_subtitle: "Karşılaştır!",
    hero_description: "AliExpress, Temu ve Shein'den en uygun fiyatları anında karşılaştır. Akıllı alışveriş, akıllı tasarruf!",
    hero_cta: "Karşılaştırmaya Başla",
    best_prices: "En İyi Fiyatlar",
    compare_platforms: "3 platformu karşılaştır",
    auto_updates: "Otomatik Güncelleme",
    realtime_sync: "Anlık senkronizasyon",
    safe_shopping: "Güvenli Alışveriş",
    direct_stores: "Mağazalara yönlendirme",
    products: "ürün",
    view_all: "Tümünü Gör",
    popular_products: "Popüler Ürünler",
    most_compared: "En çok karşılaştırılan ürünler",
    compare_prices: "Fiyatları Karşılaştır",
    similar_products: "Benzer Ürünler",
    product_details: "Ürün Detayları",
    product_description: "Ürün Açıklaması",
    price_comparison: "Fiyat Karşılaştırma",
    best_price: "En İyi Fiyat",
    from: "kaynak",
    buy_now: "Satın Al",
    out_of_stock: "Stokta Yok",
    savings: "Tasarruf",
    in_stock: "Stokta",
    price_range: "Fiyat Aralığı",
    platforms: "Platformlar",
    filters: "Filtreler",
    clear_filters: "Filtreleri Temizle",
    sort_by: "Sırala",
    popular: "Popüler",
    price_low_high: "Fiyat: Düşükten Yükseğe",
    price_high_low: "Fiyat: Yüksekten Düşüğe",
    newest: "En Yeni",
    biggest_discount: "En Büyük İndirim",
    footer_description: "AliExpress, Temu ve Shein fiyatlarını karşılaştırın. En iyi fırsatları anında bulun.",
    quick_links: "Hızlı Bağlantılar",
    home: "Ana Sayfa",
    contact: "İletişim",
    privacy_policy: "Gizlilik Politikası",
    terms_of_service: "Kullanım Şartları",
    all_rights_reserved: "Tüm hakları saklıdır.",
    no_products_found: "Ürün bulunamadı",
    try_adjusting_filters: "Filtreleri değiştirmeyi deneyin",
    product_not_found: "Ürün bulunamadı",
    link_copied: "Link kopyalandı!",
    share: "Paylaş",
    everything_here: "İhtiyacın olan her şey burada",
    dont_miss: "Daha İyi Fiyatları Kaçırma!",
    compare_thousands: "GLOBAL ile binlerce ürünü karşılaştır, en uygun fiyatı bul!",
  },
  fr: {
    search_placeholder: "Rechercher des produits...",
    all_products: "Tous les Produits",
    category_products: "Produits de la catégorie",
    go_to_store: "Aller à la boutique",
    admin: "Admin",
    categories: "Catégories",
    hero_title: "Comparez les Prix.",
    hero_subtitle: "Achetez Malin!",
    hero_description: "Comparez instantanément les prix d'AliExpress, Temu et Shein. Shopping intelligent, économies intelligentes!",
    hero_cta: "Commencer à Comparer",
    best_prices: "Meilleurs Prix",
    compare_platforms: "Comparer 3 plateformes",
    auto_updates: "Mises à jour Auto",
    realtime_sync: "Sync en temps réel",
    safe_shopping: "Achat Sécurisé",
    direct_stores: "Direct aux boutiques",
    products: "produits",
    view_all: "Voir Tout",
    popular_products: "Produits Populaires",
    most_compared: "Produits les plus comparés",
    compare_prices: "Comparer les Prix",
    similar_products: "Produits Similaires",
    product_details: "Détails du Produit",
    product_description: "Description du Produit",
    price_comparison: "Comparaison des Prix",
    best_price: "Meilleur Prix",
    from: "de",
    buy_now: "Acheter",
    out_of_stock: "Rupture de Stock",
    savings: "Économisez",
    in_stock: "En Stock",
    price_range: "Gamme de Prix",
    platforms: "Plateformes",
    filters: "Filtres",
    clear_filters: "Effacer les Filtres",
    sort_by: "Trier par",
    popular: "Populaire",
    price_low_high: "Prix: Croissant",
    price_high_low: "Prix: Décroissant",
    newest: "Plus Récent",
    biggest_discount: "Plus Grande Remise",
    footer_description: "Comparez les prix sur AliExpress, Temu et Shein. Trouvez les meilleures offres instantanément.",
    quick_links: "Liens Rapides",
    home: "Accueil",
    contact: "Contact",
    privacy_policy: "Politique de Confidentialité",
    terms_of_service: "Conditions d'Utilisation",
    all_rights_reserved: "Tous droits réservés.",
    no_products_found: "Aucun produit trouvé",
    try_adjusting_filters: "Essayez d'ajuster vos filtres",
    product_not_found: "Produit non trouvé",
    link_copied: "Lien copié!",
    share: "Partager",
    everything_here: "Tout ce dont vous avez besoin est ici",
    dont_miss: "Ne Manquez Pas les Meilleurs Prix!",
    compare_thousands: "Comparez des milliers de produits avec GLOBAL et trouvez les meilleures offres!",
  },
  de: {
    search_placeholder: "Produkte suchen...",
    all_products: "Alle Produkte",
    category_products: "Kategorie Produkte",
    go_to_store: "Zum Shop",
    admin: "Admin",
    categories: "Kategorien",
    hero_title: "Preise Vergleichen.",
    hero_subtitle: "Schlauer Einkaufen!",
    hero_description: "Vergleichen Sie sofort Preise von AliExpress, Temu und Shein. Intelligentes Einkaufen, intelligentes Sparen!",
    hero_cta: "Vergleich Starten",
    best_prices: "Beste Preise",
    compare_platforms: "3 Plattformen vergleichen",
    auto_updates: "Auto-Updates",
    realtime_sync: "Echtzeit-Sync",
    safe_shopping: "Sicheres Einkaufen",
    direct_stores: "Direkt zu Shops",
    products: "Produkte",
    view_all: "Alle Anzeigen",
    popular_products: "Beliebte Produkte",
    most_compared: "Meist verglichene Produkte",
    compare_prices: "Preise Vergleichen",
    similar_products: "Ähnliche Produkte",
    product_details: "Produktdetails",
    product_description: "Produktbeschreibung",
    price_comparison: "Preisvergleich",
    best_price: "Bester Preis",
    from: "von",
    buy_now: "Kaufen",
    out_of_stock: "Nicht Verfügbar",
    savings: "Sparen",
    in_stock: "Auf Lager",
    price_range: "Preisbereich",
    platforms: "Plattformen",
    filters: "Filter",
    clear_filters: "Filter Löschen",
    sort_by: "Sortieren nach",
    popular: "Beliebt",
    price_low_high: "Preis: Aufsteigend",
    price_high_low: "Preis: Absteigend",
    newest: "Neueste",
    biggest_discount: "Größter Rabatt",
    footer_description: "Vergleichen Sie Preise auf AliExpress, Temu und Shein. Finden Sie sofort die besten Angebote.",
    quick_links: "Schnelllinks",
    home: "Startseite",
    contact: "Kontakt",
    privacy_policy: "Datenschutz",
    terms_of_service: "Nutzungsbedingungen",
    all_rights_reserved: "Alle Rechte vorbehalten.",
    no_products_found: "Keine Produkte gefunden",
    try_adjusting_filters: "Versuchen Sie, Ihre Filter anzupassen",
    product_not_found: "Produkt nicht gefunden",
    link_copied: "Link kopiert!",
    share: "Teilen",
    everything_here: "Alles was Sie brauchen ist hier",
    dont_miss: "Verpassen Sie Nicht die Besten Preise!",
    compare_thousands: "Vergleichen Sie tausende Produkte mit GLOBAL und finden Sie die besten Angebote!",
  },
  it: {
    search_placeholder: "Cerca prodotti...",
    all_products: "Tutti i Prodotti",
    category_products: "Prodotti della categoria",
    go_to_store: "Vai al negozio",
    admin: "Admin",
    categories: "Categorie",
    hero_title: "Confronta i Prezzi.",
    hero_subtitle: "Acquista Intelligente!",
    hero_description: "Confronta istantaneamente i prezzi di AliExpress, Temu e Shein. Shopping intelligente, risparmio intelligente!",
    hero_cta: "Inizia a Confrontare",
    best_prices: "Migliori Prezzi",
    compare_platforms: "Confronta 3 piattaforme",
    auto_updates: "Aggiornamenti Auto",
    realtime_sync: "Sync in tempo reale",
    safe_shopping: "Acquisto Sicuro",
    direct_stores: "Diretto ai negozi",
    products: "prodotti",
    view_all: "Vedi Tutto",
    popular_products: "Prodotti Popolari",
    most_compared: "Prodotti più confrontati",
    compare_prices: "Confronta Prezzi",
    similar_products: "Prodotti Simili",
    product_details: "Dettagli Prodotto",
    product_description: "Descrizione Prodotto",
    price_comparison: "Confronto Prezzi",
    best_price: "Miglior Prezzo",
    from: "da",
    buy_now: "Acquista",
    out_of_stock: "Esaurito",
    savings: "Risparmi",
    in_stock: "Disponibile",
    price_range: "Fascia di Prezzo",
    platforms: "Piattaforme",
    filters: "Filtri",
    clear_filters: "Cancella Filtri",
    sort_by: "Ordina per",
    popular: "Popolare",
    price_low_high: "Prezzo: Crescente",
    price_high_low: "Prezzo: Decrescente",
    newest: "Più Recente",
    biggest_discount: "Maggior Sconto",
    footer_description: "Confronta i prezzi su AliExpress, Temu e Shein. Trova le migliori offerte istantaneamente.",
    quick_links: "Link Rapidi",
    home: "Home",
    contact: "Contatto",
    privacy_policy: "Privacy Policy",
    terms_of_service: "Termini di Servizio",
    all_rights_reserved: "Tutti i diritti riservati.",
    no_products_found: "Nessun prodotto trovato",
    try_adjusting_filters: "Prova a modificare i filtri",
    product_not_found: "Prodotto non trovato",
    link_copied: "Link kopiert!",
    share: "Condividi",
    everything_here: "Tutto ciò di cui hai bisogno è qui",
    dont_miss: "Non Perdere i Prezzi Migliori!",
    compare_thousands: "Confronta migliaia di prodotti con GLOBAL e trova le migliori offerte!",
  },
  es: {
    search_placeholder: "Buscar productos...",
    all_products: "Todos los Productos",
    category_products: "Productos de categoría",
    go_to_store: "Ir a la tienda",
    admin: "Admin",
    categories: "Categorías",
    hero_title: "Compara Precios.",
    hero_subtitle: "¡Compra Inteligente!",
    hero_description: "Compara precios de AliExpress, Temu y Shein al instante. ¡Compras inteligentes, ahorros inteligentes!",
    hero_cta: "Empezar a Comparar",
    best_prices: "Mejores Precios",
    compare_platforms: "Compara 3 plataformas",
    auto_updates: "Actualizaciones Auto",
    realtime_sync: "Sync en tiempo real",
    safe_shopping: "Compra Segura",
    direct_stores: "Directo a tiendas",
    products: "productos",
    view_all: "Ver Todo",
    popular_products: "Productos Populares",
    most_compared: "Productos más comparados",
    compare_prices: "Comparar Precios",
    similar_products: "Productos Similares",
    product_details: "Detalles del Producto",
    product_description: "Descripción del Producto",
    price_comparison: "Comparación de Precios",
    best_price: "Mejor Precio",
    from: "de",
    buy_now: "Comprar",
    out_of_stock: "Agotado",
    savings: "Ahorra",
    in_stock: "En Stock",
    price_range: "Rango de Precio",
    platforms: "Plataformas",
    filters: "Filtres",
    clear_filters: "Limpiar Filtros",
    sort_by: "Ordenar por",
    popular: "Popular",
    price_low_high: "Precio: Menor a Mayor",
    price_high_low: "Precio: Mayor a Menor",
    newest: "Más Nuevo",
    biggest_discount: "Mayor Descuento",
    footer_description: "Compara precios en AliExpress, Temu y Shein. Encuentra las mejores ofertas al instante.",
    quick_links: "Enlaces Rápidos",
    home: "Inicio",
    contact: "Contacto",
    privacy_policy: "Política de Privacidad",
    terms_of_service: "Términos de Servicio",
    all_rights_reserved: "Todos los derechos reservados.",
    no_products_found: "No se encontraron productos",
    try_adjusting_filters: "Intenta ajustar tus filtros",
    product_not_found: "Producto no encontrado",
    link_copied: "¡Enlace copiado!",
    share: "Compartir",
    everything_here: "Todo lo que necesitas está aquí",
    dont_miss: "¡No Te Pierdas los Mejores Precios!",
    compare_thousands: "¡Compara miles de productos con GLOBAL y encuentra las mejores ofertas!",
  },
  nl: {
    search_placeholder: "Producten zoeken...",
    all_products: "Alle Producten",
    category_products: "Categorie Producten",
    go_to_store: "Naar de winkel",
    admin: "Admin",
    categories: "Categorieën",
    hero_title: "Vergelijk Prijzen.",
    hero_subtitle: "Shop Slimmer!",
    hero_description: "Vergelijk direct prijzen van AliExpress, Temu en Shein. Slim winkelen, slim besparen!",
    hero_cta: "Begin met Vergelijken",
    best_prices: "Beste Prijzen",
    compare_platforms: "Vergelijk 3 platforms",
    auto_updates: "Auto Updates",
    realtime_sync: "Realtime sync",
    safe_shopping: "Veilig Winkelen",
    direct_stores: "Direct naar winkels",
    products: "producten",
    view_all: "Bekijk Alles",
    popular_products: "Populaire Producten",
    most_compared: "Meest vergeleken producten",
    compare_prices: "Vergelijk Prijzen",
    similar_products: "Vergelijkbare Producten",
    product_details: "Productdetails",
    product_description: "Productbeschrijving",
    price_comparison: "Prijsvergelijking",
    best_price: "Beste Prijs",
    from: "van",
    buy_now: "Kopen",
    out_of_stock: "Niet op Voorraad",
    savings: "Bespaar",
    in_stock: "Op Voorraad",
    price_range: "Prijsbereik",
    platforms: "Platforms",
    filters: "Filters",
    clear_filters: "Filters Wissen",
    sort_by: "Sorteren op",
    popular: "Populair",
    price_low_high: "Prijs: Laag naar Hoog",
    price_high_low: "Prijs: Hoog naar Laag",
    newest: "Nieuwste",
    biggest_discount: "Grootste Korting",
    footer_description: "Vergelijk prijzen op AliExpress, Temu en Shein. Vind direct de beste deals.",
    quick_links: "Snelle Links",
    home: "Home",
    contact: "Contact",
    privacy_policy: "Privacybeleid",
    terms_of_service: "Servicevoorwaarden",
    all_rights_reserved: "Alle rechten voorbehouden.",
    no_products_found: "Geen producten gevonden",
    try_adjusting_filters: "Probeer je filters aan te passen",
    product_not_found: "Product niet gevonden",
    link_copied: "Link gekopieerd!",
    share: "Delen",
    everything_here: "Alles wat je hebt is hier",
    dont_miss: "Mis de Beste Prijzen Niet!",
    compare_thousands: "Vergelijk duizenden producten met GLOBAL en vind de beste deals!",
  },
};

export const languageOptions = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
];

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    const saved = localStorage.getItem('global_language');
    // Önce kayıtlı dili, yoksa tarayıcı dilini, en son 'fr'yi seçer.
    return (saved && translations[saved]) ? saved : 'fr'; 
  });

  useEffect(() => {
    localStorage.setItem('global_language', language);
    document.documentElement.lang = language;
  }, [language]);

  const setLanguage = (lang) => {
    if (translations[lang]) {
      setLanguageState(lang);
    }
  };

  const t = (key) => {
    // Mevcut dilde yoksa 'en' diline, o da yoksa anahtara döner.
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };

  // 'r.map' hatasını önlemek için güvenli dizi oluşturma
  const availableLanguages = languageOptions.filter(opt => translations[opt.code]) || [];

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      t, 
      availableLanguages,
      translations 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};
